import { create } from 'zustand';

interface DebugState {
    fps: number;
    drawCalls: number;
    triangles: number;
    update: (fps: number, drawCalls: number, triangles: number) => void;
}

export const useDebugStore = create<DebugState>((set) => ({
    fps: 0,
    drawCalls: 0,
    triangles: 0,
    update: (fps, drawCalls, triangles) => set({ fps, drawCalls, triangles }),
}));
